import { render, staticRenderFns } from "./InfoCardLoader.vue?vue&type=template&id=84f9f346"
import script from "./InfoCardLoader.vue?vue&type=script&lang=ts"
export * from "./InfoCardLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports